import { render, staticRenderFns } from "./databaseInfo.vue?vue&type=template&id=1c427dd7&scoped=true&"
import script from "./databaseInfo.vue?vue&type=script&lang=js&"
export * from "./databaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./databaseInfo.vue?vue&type=style&index=0&id=1c427dd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c427dd7",
  null
  
)

export default component.exports